import styled from "@emotion/styled";
import NavigationBar, {
  navBarHeight,
} from "../../../components/navigation/ContentPageNav";
import HeaderAnimation from "./HeaderAnimation";
import {
  breakpoints,
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  nav,
  text,
} from "@atlas-int/tokens";

const atlasBlue = nav.background;

const bpTablet = breakpoints.headerMobile;
const bpMobile = breakpoints.xxs;

const HeaderBackgroundContainer = styled.div`
  position: absolute;
  z-index: -1;
  top: 0px;
  left: 0;
  right: 0;
  overflow: hidden;
  background: ${atlasBlue};
  width: 100%;
  min-height: 420px;

  @media (max-width: ${bpTablet}) {
    min-height: 320px;
  }

  @media (max-width: ${bpMobile}) {
    min-height: 280px;
  }
`;

const HeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;
  height: calc(420px - ${navBarHeight});
  gap: 2rem;

  @media (max-width: ${breakpoints.md}) {
    padding: 1rem 1.5rem;
    gap: 1rem;
  }

  @media (max-width: ${bpTablet}) {
    height: calc(320px - ${navBarHeight});
    padding: 1rem;
    gap: 0.75rem;
  }

  @media (max-width: ${bpMobile}) {
    height: calc(280px - ${navBarHeight});
    gap: 0.5rem;
  }
`;

const HeaderLeft = styled.div`
  flex: 1;
  min-width: 0;
  color: ${text.onDark};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 729px;

  @media (max-width: ${breakpoints.md}) {
    max-width: 100%;
  }
`;

const HeaderRight = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.md}) {
    flex-shrink: 1;
  }
`;

const HeaderTitle = styled.h1`
  font-family: ${fontFamily.base}, sans-serif;
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize["5xl"]};
  text-transform: uppercase;
  color: ${text.onDark};
  margin: 0 0 1rem 0;
  text-align: center;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${fontSize["4xl"]};
  }

  @media (max-width: ${bpTablet}) {
    font-size: ${fontSize["3xl"]};
    margin: 0 0 0.75rem 0;
  }

  @media (max-width: ${bpMobile}) {
    font-size: ${fontSize["2xl"]};
    margin: 0 0 0.5rem 0;
  }
`;

const Description = styled.p`
  font-family: ${fontFamily.base}, sans-serif;
  font-size: ${fontSize["3xl"]};
  line-height: ${lineHeight.normal};
  font-weight: ${fontWeight.normal};
  margin: 0 0 1.5rem 0;
  color: ${text.onDark};
  text-align: center;

  @media (max-width: ${breakpoints.md}) {
    font-size: ${fontSize["2xl"]};
  }

  @media (max-width: ${bpTablet}) {
    font-size: ${fontSize.lg};
    line-height: ${lineHeight.snug};
    margin: 0 0 1rem 0;
  }

  @media (max-width: ${bpMobile}) {
    font-size: ${fontSize.base};
    margin: 0 0 0.75rem 0;
  }
`;

const LowerContentContainer = styled.div`
  color: ${text.onDark};
`;

const MinHeightContainer = styled.div`
  position: relative;
  min-height: 420px;

  @media (max-width: ${bpTablet}) {
    min-height: 320px;
  }

  @media (max-width: ${bpMobile}) {
    min-height: 280px;
  }
`;

const HeaderBanner = () => {
  return (
    <MinHeightContainer>
      <HeaderBackgroundContainer />
      <NavigationBar isHomePage={true} />
      <LowerContentContainer>
        <HeaderContentWrapper>
          <HeaderLeft>
            <HeaderTitle>Atlas of Economic Complexity</HeaderTitle>
            <Description>
              Harvard Growth Lab's research and data visualization tool used to
              understand the economic dynamics and new growth opportunities for
              every country worldwide.
            </Description>
          </HeaderLeft>
          <HeaderRight>
            <HeaderAnimation />
          </HeaderRight>
        </HeaderContentWrapper>
      </LowerContentContainer>
    </MinHeightContainer>
  );
};

export default HeaderBanner;
